import { Template } from "../template"
import { PhysicsEngine } from "./physics"
import { map, getRandom } from "../utils/math"
import { Generator } from "../utils/generator"

const Box2D = require("../../vendors/box2d.web.js")

class Jampack extends Template {
  constructor() {
    super("Super Awesome Jampack")
  }

  setup() {
    const canvas = document.createElement("canvas")
    document.body.appendChild(canvas)

    this.context = canvas.getContext("2d")

    this.generator = null

    // 16 april 2021
    this.bodies = []
    // if user is dragging a body
    this.downbody = null
    // temp size before pushing to scene
    this.temp = { x: 0, y: 0, radius: 1 }
    // array of bodies to dispose
    this.frameDispose = []

    this.min = 30
    this.max = 150
    this.initialBodies = 4
    this.maxBodies = 12

    this.physics = new PhysicsEngine(this.width, this.height, false)
    this.physics.init()

    for (let i = 0; i < this.initialBodies; i++) {
      setTimeout(() => {
        const r = getRandom(this.min, this.max)
        this.addBody(this.width / 2 + Math.random(), r, r, false)
      }, 100 * i)
    }
  }

  addBody(x, y, r, triggeredByUserClick = false) {
    this.bodies.push(
      this.physics.createCircle(r, x, y, Box2D.Dynamics.b2Body.b2_dynamicBody, {
        lifespan: getRandom(120, 240),
        immortal: true,
      })
    )

    if (triggeredByUserClick) {
      if (!this.generator) {
        this.generator = new Generator()
      }

      this.generator.tone(map(r, this.min, this.max, 1000, 200), "sine", 0.5)
    }

    if (this.bodies.length > this.maxBodies) {
      this.deleteBodyAtIndex(0)
    }

    // if available area is cramped also delete
    // const total = (this.width * this.height) / this.ratio
    // const current = this.max * this.max * this.bodies.length * 2
    // const busyPercentage = (current * 100) / total

    while (this.evaluateArea() >= 80) {
      // console.log("too crowded, kill one")
      this.deleteBodyAtIndex(0)
    }
  }

  evaluateArea() {
    const total = (this.width * this.height) / this.ratio
    let current = 0
    for (let i = 0; i < this.bodies.length; i++) {
      current +=
        this.bodies[i].m_userData.radius * this.bodies[i].m_userData.radius
    }
    current *= 2
    this.max * this.max * this.bodies.length * 2
    const busyPercentage = (current * 100) / total

    // console.log(
    //   "total",
    //   total,
    //   "current",
    //   current,
    //   "percentage",
    //   busyPercentage
    // )

    return busyPercentage
  }

  deleteBodyAtIndex(bodyIndex) {
    const current = this.bodies.splice(bodyIndex, 1)[0]
    this.physics.destroy(current)
  }

  resize(width, height, ratio) {
    this.context.canvas.width = width * ratio
    this.context.canvas.height = height * ratio
    this.context.canvas.style.width = `${width}px`
    this.context.canvas.style.height = `${height}px`

    this.physics.resize(width, height)
  }

  drawCircle(x, y, radius) {
    this.context.beginPath()
    this.context.fillStyle = "black"
    this.context.arc(x, y, radius, 0, 2 * Math.PI)
    this.context.fill()
    this.context.closePath()
  }

  drawCross(x, y, angle, size, offsetX, offsetY) {
    this.context.beginPath()

    this.context.save()
    this.context.translate(x, y)
    this.context.rotate(angle)

    this.context.moveTo(offsetX, offsetY)
    this.context.lineTo(offsetX - size, offsetY)
    this.context.lineTo(offsetX + size, offsetY)

    this.context.moveTo(offsetX, offsetY)
    this.context.lineTo(offsetX, offsetY - size)
    this.context.lineTo(offsetX, offsetY + size)

    this.context.strokeStyle = "white"
    this.context.stroke()
    this.context.lineWidth = 2 * this.ratio

    this.context.restore()
    this.context.closePath()
  }

  update() {
    this.physics.update()

    this.context.clearRect(
      0,
      0,
      this.context.canvas.width,
      this.context.canvas.height
    )

    const size = 5 * this.ratio
    const space = 20 * this.ratio

    for (let i = 0; i < this.bodies.length; i++) {
      const pos = this.bodies[i].GetPosition()
      const angle = this.bodies[i].GetAngle()
      const x = pos.x * this.ratio * this.physics.worldScale
      const y = pos.y * this.ratio * this.physics.worldScale
      const radius = this.bodies[i].m_userData.radius * this.ratio

      // draw shape
      this.drawCircle(x, y, radius)
      this.drawCross(x, y, angle, size, radius - space, 0)
      this.drawCross(x, y, angle, size, 0 - radius + space, 0)

      // lifespan
      if (!this.bodies[i].m_userData.immortal) {
        this.bodies[i].m_userData.lifespan--
        if (this.bodies[i].m_userData.lifespan <= 0) {
          this.frameDispose.push(i)
        }
      }
    }

    // dispose of old bodies
    while (this.frameDispose.length > 0) {
      this.deleteBodyAtIndex(this.frameDispose[0])

      this.frameDispose.shift()
    }

    // draw temp
    if (this.mouse.down && !this.downbody) {
      this.temp.x = this.mouse.x
      this.temp.y = this.mouse.y
      this.temp.radius =
        map(0.5 + 0.5 * Math.cos(Date.now() / 200), 0, 1, this.min, this.max) *
        this.ratio
      this.drawCircle(this.temp.x, this.temp.y, this.temp.radius)
      this.drawCross(
        this.temp.x,
        this.temp.y,
        0,
        size,
        this.temp.radius - space,
        0
      )
      this.drawCross(
        this.temp.x,
        this.temp.y,
        0,
        size,
        0 - this.temp.radius + space,
        0
      )
    }
  }

  down(x, y) {
    this.downbody = this.physics.down(x / this.ratio, y / this.ratio)
  }

  move(x, y) {
    if (this.mouse.down) {
      this.physics.move(x / this.ratio, y / this.ratio)
    }
  }

  up(x, y) {
    this.physics.up(x / this.ratio, y / this.ratio)

    // add body
    if (!this.downbody) {
      this.addBody(
        this.temp.x / this.ratio,
        this.temp.y / this.ratio,
        this.temp.radius / this.ratio,
        true
      )
    }
    this.downbody = null
  }
}

const app = new Jampack()
